import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";

function Vision() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);
  return (
    <Container>
      <Slot data-aos="fade-right">
        <h1>Our Vision</h1>
        <p>
          We create videos to communicate your vision, mission & services that
          express our values. We create videos to inspire creative minds.
        </p>
      </Slot>

      <Slot data-aos="fade-left">
        <h1>Our Team</h1>
        <p>
          With a relentless pursuit of perfection, our dynamic team at "IBEX
          FILMZ" combines youthful energy with seasoned expertise to elevate
          every project we undertake. Through meticulous attention to detail and
          a passion for storytelling, we transform the ordinary into the
          extraordinary, crafting visual narratives that resonate deeply with
          audiences.
        </p>
      </Slot>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  background: var(--primary-color);
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 20px;
`;

const Slot = styled.div`
  width: 40%;
  height: 350px;
  display: flex;
  flex-direction: column;
  padding: 50px;
  color: #fff;
  align-items: center;
  background: linear-gradient(#000, var(--secondary-background-color))
      padding-box,
    linear-gradient(
        145deg,
        transparent 35%,
        var(--secondary-color),
        var(--secondary-color)
      )
      border-box;
  border: 2px solid transparent;
  border-radius: 16px;
  margin: 40px;
  box-shadow: 0px 187px 75px rgba(0, 0, 0, 0.01),
    0px 105px 63px rgba(0, 0, 0, 0.05), 0px 47px 47px rgba(0, 0, 0, 0.09),
    0px 12px 26px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);

  @media only screen and (max-width: 1024px) {
    width: 80%;
    height: auto;
    padding: 30px;
    margin: 20px 0;
  }

  @media only screen and (max-width: 768px) {
    width: 96%;
    padding: 25px;
    margin: 15px 0;
  }

  h1 {
    margin-bottom: 30px;
    font-size: 32px;

    @media only screen and (max-width: 1024px) {
      font-size: 28px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 26px;
    }
  }

  p {
    line-height: 1.8rem;
    text-align: center;
    margin-top: 10px;
    font-size: 15px;

    @media only screen and (max-width: 1024px) {
      font-size: 14px;
      line-height: 1.6rem;
    }

    @media only screen and (max-width: 768px) {
      font-size: 13px;
      line-height: 1.5rem;
    }
  }
`;

export default Vision;
